export default __webpack_public_path__ + "static/media/follow-up-with-guides.cd92ebc8.svg";